import { render, staticRenderFns } from "./WorkpostcuttingPage.vue?vue&type=template&id=43f43a48"
import script from "./WorkpostcuttingPage.vue?vue&type=script&lang=js"
export * from "./WorkpostcuttingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports